import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from '../../const';

enum MessageTypes {
  NEW_TAB_OPENED,
  TAB_EXISTS,
}

export const useTabInterceptor = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof BroadcastChannel !== 'undefined') {
      const bc = new BroadcastChannel('channel');
      const listener = ({ data }) => {
        if (data === MessageTypes.NEW_TAB_OPENED) {
          bc.postMessage(MessageTypes.TAB_EXISTS);
        }
        if (data === MessageTypes.TAB_EXISTS) {
          navigate(RoutePath.ERROR_DUPLICATE);
        }
      };

      bc.addEventListener('message', listener);

      bc.postMessage(MessageTypes.NEW_TAB_OPENED);

      return () => {
        bc.removeEventListener('message', listener);
      };
    }
  }, [navigate]);
};
